module.exports = __webpack_public_path__ + "static/media/partyPopper.4ef7dbb0.svg";